/**
 * @generated SignedSource<<f23c6489035f1d71381511c9d9dfb8fb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Nav4PlansForLanding$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PlansList" | "PlansListRefactored">;
  readonly " $fragmentType": "Nav4PlansForLanding";
};
export type Nav4PlansForLanding$key = {
  readonly " $data"?: Nav4PlansForLanding$data;
  readonly " $fragmentSpreads": FragmentRefs<"Nav4PlansForLanding">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "Nav4PlansForLanding",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PlansList"
    },
    {
      "kind": "FragmentSpread",
      "name": "PlansListRefactored"
    }
  ],
  "type": "Query"
};

(node as any).hash = "8ab5419bdc47008e064e4b92b964957b";

export default node;
